/**
 * Approved upgrade copy shared by every paid-feature gate.
 *
 * Keeping both languages here ensures that each gate makes the same promise
 * and prevents individual screens from growing their own sales language.
 */
const MESSAGES = {
  en: {
    default: {
      eyebrow: 'JOBSEEQR PRO',
      title: 'Unlock the complete JOBSEEQR system.',
      description: 'Scout, outreach, Learning Pathways, interview practice, Company Radar and Career Coach.',
      cta: 'Upgrade to Pro · $20/month',
    },
    scout: {
      eyebrow: 'JOBSEEQR PRO',
      title: 'Keep your job search active.',
      description: 'Your roles, locations and preferences are already saved. Upgrade so JOBSEEQR can continue searching for jobs for you.',
      cta: 'Keep my Scout active · $20/month',
    },
    scout_edit: {
      eyebrow: 'SCOUT',
      title: 'Update what Scout searches for.',
      description: 'Change your preferred roles, locations, work mode and priorities as your career goals evolve.',
      cta: 'Update my Scout with Pro',
    },
    outreach: {
      eyebrow: 'OUTREACH',
      title: 'Contact the hiring team behind every job you apply for.',
      description: 'Find relevant recruiters, write tailored messages based on the job and automatically email them with follow-ups designed to help you land roles much faster.',
      cta: 'Contact the hiring team',
    },
    career_coach: {
      eyebrow: 'CAREER COACH',
      title: 'Continue talking to your Career Coach.',
      description: 'Your Coach remembers your CV, career goals and job search, and works for you to get you closer to where you want to be.',
      cta: 'Continue with Pro',
    },
    company_radar: {
      eyebrow: 'COMPANY RADAR',
      title: 'Build a clear path into the companies you want to join.',
      description: 'See where you fit, what to improve, who to connect with for a possible referral, and what to do next. This includes visa checks and a step-by-step plan.',
      cta: 'Build my company list',
    },
    interview: {
      eyebrow: 'INTERVIEW PRACTICE',
      title: 'Go into your next interview with better answers.',
      description: 'Practice questions for the job out loud, then see what was missing and how to give a better answer.',
      cta: 'Start practicing with Pro',
    },
    learning_pathways: {
      eyebrow: 'LEARNING PATHWAYS',
      title: 'Build the skills your next job needs.',
      description: 'Compare your CV with the job you want, see your strengths and what you must improve, and get a clear plan to build and prove those skills.',
      cta: 'Build my Learning Pathway',
    },
  },
  ar: {
    default: {
      eyebrow: 'JOBSEEQR PRO',
      title: 'احصل على نظام JOBSEEQR الكامل.',
      description: 'مساعد البحث والتواصل ومسارات التعلّم والتدرّب على المقابلات ورادار الشركات والمدرب المهني.',
      cta: 'الترقية إلى Pro · 20 دولاراً شهرياً',
    },
    scout: {
      eyebrow: 'JOBSEEQR PRO',
      title: 'حافظ على نشاط بحثك عن عمل.',
      description: 'تم حفظ الوظائف والمواقع والتفضيلات التي اخترتها. قم بالترقية كي يواصل JOBSEEQR البحث عن الوظائف نيابةً عنك.',
      cta: 'أبقِ مساعدي نشطاً · 20 دولاراً شهرياً',
    },
    scout_edit: {
      eyebrow: 'مساعد البحث',
      title: 'حدّث ما يبحث عنه مساعدك.',
      description: 'غيّر الوظائف والمواقع ونظام العمل والأولويات التي تفضّلها مع تطور أهدافك المهنية.',
      cta: 'حدّث مساعدي مع Pro',
    },
    outreach: {
      eyebrow: 'التواصل',
      title: 'تواصل مع فريق التوظيف لكل وظيفة تتقدم إليها.',
      description: 'اعثر على مسؤولي التوظيف المناسبين، واكتب رسائل مخصصة بناءً على الوظيفة، ثم أرسلها تلقائياً مع رسائل متابعة مصممة لمساعدتك على الحصول على وظيفة بشكل أسرع.',
      cta: 'تواصل مع فريق التوظيف',
    },
    career_coach: {
      eyebrow: 'المدرب المهني',
      title: 'واصل الحديث مع مدربك المهني.',
      description: 'يتذكر مدربك سيرتك الذاتية وأهدافك المهنية وبحثك عن عمل، ويعمل من أجلك لتقترب من المكان الذي تريد الوصول إليه.',
      cta: 'المتابعة مع Pro',
    },
    company_radar: {
      eyebrow: 'رادار الشركات',
      title: 'ابنِ طريقاً واضحاً إلى الشركات التي تريد الانضمام إليها.',
      description: 'اعرف أين تناسب الشركة، وما الذي تحتاج إلى تحسينه، ومع من تتواصل للحصول على ترشيح محتمل، وما الخطوات التالية، بما في ذلك التأشيرة وخطة واضحة.',
      cta: 'أنشئ قائمة شركاتي',
    },
    interview: {
      eyebrow: 'التدرّب على المقابلات',
      title: 'ادخل مقابلتك القادمة بإجابات أفضل.',
      description: 'تدرّب بصوتك على أسئلة الوظيفة، ثم اعرف ما كان ناقصاً وكيف تعطي إجابة أفضل.',
      cta: 'ابدأ التدرّب مع Pro',
    },
    learning_pathways: {
      eyebrow: 'مسارات التعلّم',
      title: 'طوّر المهارات التي تحتاجها وظيفتك القادمة.',
      description: 'قارن سيرتك الذاتية بالوظيفة التي تريدها، وشاهد نقاط قوتك وما يجب تحسينه، واحصل على خطة واضحة لبناء هذه المهارات وإثباتها.',
      cta: 'أنشئ مسار التعلّم الخاص بي',
    },
  },
};

export function upgradeMessage(context = 'default', language = 'en') {
  const localized = MESSAGES[language] || MESSAGES.en;
  return localized[context] || localized.default;
}

export const PRO_PRICE_LABEL = '$20';
